import { render, staticRenderFns } from "./VluList.vue?vue&type=template&id=acb6af3e&scoped=true"
import script from "./VluList.vue?vue&type=script&lang=js"
export * from "./VluList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb6af3e",
  null
  
)

export default component.exports